import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AlgPreConsentComponent } from './components/alg-pre-consent/alg-pre-consent.component';
import { AlgBillingFrequencyComponent } from './pages/alg-billing-frequency/alg-billing-frequency.component';
import { AlgChangePlanComponent } from './pages/alg-change-plan/alg-change-plan-component';
import { AlgConsensoUnipolComponent } from './pages/alg-consenso-unipol/alg-consenso-unipol.component';
import { AlgConsensoComponent } from './pages/alg-consenso/alg-consenso.component';
import { AlgConsensoAgileRequestComponent } from './pages/alg-consent-agile-request/alg-consent-agile-request';
import { AlgConsensoFissoRequestComponent } from './pages/alg-consent-fisso-request/alg-consent-fisso-request';
import { AlgEmailManagementComponent } from './pages/alg-email-management/alg-email-management.component';
import { AlgLinearConsentRequestComponent } from './pages/alg-linear-consent-request/alg-linear-consent-request';
import { AlgPaymentMethodComponent } from './pages/alg-payment-method/alg-payment-method.component';
import { AlgSupplyInvoiceComponent } from './pages/alg-supply-invoice/alg-supply-invoice.component';
import { AlgSwitchPageComponent } from './pages/alg-switch-page/alg-switch-page.component';

const routes: Routes = [
  { path: 'agile', component: AlgConsensoAgileRequestComponent }, // non esiste
  { path: 'fisso', component: AlgConsensoFissoRequestComponent },
  { path: 'cambio-periodicita', component: AlgBillingFrequencyComponent },
  { path: 'cambio-piano', component: AlgChangePlanComponent },
  { path: 'ricezione-documenti', component: AlgEmailManagementComponent },
  { path: 'ricezione-fatture-fornitura', component: AlgSupplyInvoiceComponent },
  { path: 'modalita-pagamento', component: AlgPaymentMethodComponent },
  { path: ':id', component: AlgSwitchPageComponent },
  // { path: 'unipol/:id', component: AlgConsensoUnipolComponent },
  { path: '', component: AlgLinearConsentRequestComponent },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)],
})
export class ConsensoRoutingModule {}

export const pageComponentsConsenso: any[] = [
  AlgConsensoUnipolComponent,
  AlgSwitchPageComponent,
  AlgConsensoComponent,
  AlgLinearConsentRequestComponent,
  AlgConsensoAgileRequestComponent,
  AlgPaymentMethodComponent,
  AlgSupplyInvoiceComponent,
  AlgConsensoFissoRequestComponent,
  AlgChangePlanComponent,
  AlgEmailManagementComponent,
  AlgBillingFrequencyComponent,
  AlgPreConsentComponent,
];



// WEBPACK FOOTER //
// ./src/app/consenso.route.ts